export default class BecomeMember {
	constructor(el) {
		this.el = el;
		this.currentElem = null;
		this.items = this.el.querySelectorAll('[data-join-bam-item]');

		const images = Array.from(this.el.querySelectorAll('.c-img-video'));

		this.el.addEventListener('mouseover', (e) => {
			if (!window.matchMedia('(min-width:992px)').matches) {
				return;
			}

			if (this.currentElem) {
				return;
			}

			let target = e.target.closest('[data-join-bam-item]');

			if (!target) {
				return;
			}

			this.currentElem = target;
			this.activateElement(images[parseInt(this.currentElem.dataset.joinBamItem, 10) + 1]);
		});

		this.el.addEventListener('mouseout', (e) => {
			if (!window.matchMedia('(min-width:992px)').matches) {
				return;
			}

			if (!this.currentElem) {
				return;
			}

			let relatedTarget = e.relatedTarget;

			while (relatedTarget) {
				if (relatedTarget == this.currentElem) {
					return;
				}

				relatedTarget = relatedTarget.parentNode;
			}

			this.deactivateElement(images[parseInt(this.currentElem.dataset.joinBamItem, 10) + 1]);
			this.currentElem = null;
		});
	}

	activateElement(el) {
		el.classList.add('is-active');
		this.items.forEach((item) => {
			if (item == this.currentElem) {
				return;
			}

			item.classList.add('is-dimmed');
		});
	}

	deactivateElement(el) {
		el.classList.remove('is-active');
		this.items.forEach((item) => item.classList.remove('is-dimmed'));
	}
}
